import { Modal, ProgressBar } from "react-bootstrap";
import React from "react";

export default function ModalLoader({
  show,
  title = "processing request...",
  progressPercent,
  ...modalProps
}) {
  return (
    <Modal
      size="sm"
      show={show}
      onHide={() => {}}
      centered
      aria-labelledby="example-modal-sizes-title-sm"
      backdrop="static"
      animation={false}
      {...modalProps}
    >
      <Modal.Body className="text-center w-100">
        <div className="my-3 d-flex align-items-center justify-content-center w-100">
          Please wait, this may take a while...
        </div>
        <div className="my-3 d-flex align-items-center justify-content-center w-100">
          {title}
        </div>
        {progressPercent ? (
          <div className="my-3 w-100">
            <ProgressBar
              now={progressPercent}
              label={`${progressPercent}%`}
              animated
              striped
              variant={progressPercent < 100 ? "pending" : "success"}
            />
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  );
}
